








































import {
  AdgroupFormData,
  CampaignFormData,
  CreateMode,
  AdgroupConfig,
  StoreType,
  CatalogStoreType,
  catalogProductFormFields,
} from '@tt4b/ttam-enums';
import { defineComponent, computed, PropType, ref, toRefs, nextTick, watch } from '@vue/composition-api';
import TtamProductSourceCatalogAlert from './alert/index.vue';
import TtamProductSourceCatalog from './catalog/index.vue';
import { useDataSource, useRules, usePropsVisible, usePropsOperationList, useCatalogCreate } from './hooks';
import OperationList from '@/components/common/operation-list/index.vue';
import TooltipInfo from '@/components/common/tooltip-info/index.vue';
import { useAdgroupMode } from '@tt4b/ttam-hooks';
import { trackEvent } from './../../../utils/index';

const name = 'ttam-product-source-catalog-compose';
export default defineComponent({
  name,
  components: {
    TtamProductSourceCatalog,
    TtamProductSourceCatalogAlert,
    OperationList,
    TooltipInfo,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    isShowLabel: {
      type: Boolean,
      default: true,
    },
    // 错误字段map，初始化后的报错信息
    errorsMap: {
      type: Object as PropType<Record<string, string>>,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
    /** 当前商品库类型 */
    catalogTypes: {
      type: Array as PropType<CatalogStoreType[]>,
      default: () => [
        StoreType.ECOM,
        StoreType.ENTERTAINMENT,
        StoreType.FLIGHT,
        StoreType.HOTEL,
        StoreType.DESTINATION,
      ],
    },
    /** 是否禁用跳转 catalog manager */
    hideGotoCatalog: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const catalogFormItemRef = ref(null);
    const catalogRef = ref(null);
    const { adgroupData, createMode, hideGotoCatalog, catalogTypes, adgroupConfig } = toRefs(props);
    const fieldConfig = computed(() => {
      const [catalogType] = catalogTypes.value;
      return catalogProductFormFields[catalogType];
    });
    const selectedCatalog = computed({
      get: () => ({
        platformId: adgroupData.value[fieldConfig.value.CATALOG_ID],
        bc_id: adgroupData.value[fieldConfig.value.BC_ID],
      }),
      set: val => {
        let newVal = {
          [fieldConfig.value.CATALOG_ID]: val.platformId,
          [fieldConfig.value.BC_ID]: val.bc_id,
        };
        emit('change', newVal);
        emit('input', newVal);
        nextTick(() => {
          catalogFormItemRef.value?.validate?.('custom');
        });
      },
    });
    const { isLoading, catalogList, getCatalogList, hasLoaded, disabledReason } = useDataSource({
      catalogTypes: catalogTypes.value,
    });
    const { isEdit } = useAdgroupMode({ createMode });
    const selectedCatalogData = computed(() => {
      const { platformId: selectPlatformId, bc_id: selectBcId } = selectedCatalog.value;
      return catalogList.value.find(({ platformId, bc_id }) => platformId === selectPlatformId && bc_id === selectBcId);
    });
    const { visible: visibleAlert } = usePropsVisible({ catalog: selectedCatalogData });

    const createCatalog = () => emit('createCatalog');

    const { openCatalog, createProduct } = useCatalogCreate({ adgroupData });
    const { operationList } = usePropsOperationList({
      refresh: () => {
        getCatalogList();
        // 这样写，可以触发那个focus的样式，ued
        catalogRef.value?.$refs?.inputRef?.focus();
      },
      selectedCatalogData,
      create: openCatalog,
      isEdit,
      hideGotoCatalog,
      adgroupConfig,
    });
    const { catalogValidator } = useRules();

    watch(catalogList, () => {
      if (hasLoaded.value) {
        const hasAvaliable = catalogList.value.filter(item => !item.disabled).length > 0;

        trackEvent('module_ad_group_has_catalog', { result: catalogList.value.length > 0 });
        trackEvent('module_ad_group_has_avaliable_catalog', {
          result: hasAvaliable,
          reason: hasAvaliable ? '0' : disabledReason.value,
        });
      }
    });

    return {
      name,
      isEdit,
      catalogFormItemRef,
      catalogRef,
      isLoading,
      visibleAlert,
      catalogList,
      selectedCatalog,
      operationList,
      catalogValidator,
      fieldConfig,
      createCatalog,
      createProduct,
      getCatalogList,
    };
  },
});
